import { FC, useMemo } from 'react';
import { Plan } from '../Plan/Plan';
import { replacePlan, sharedCourseIdsByType } from '../../lib/planEdits';
import type { PlanDraft } from '../../hooks/usePlanForm';

interface PlansProps {
  plans: PlanDraft[];
  onChange: (plans: PlanDraft[]) => void;
}

export const Plans: FC<PlansProps> = ({ plans, onChange }) => {
  const sharedByType = useMemo(() => sharedCourseIdsByType(plans), [plans]);

  return (
    <div className="flex flex-col gap-4">
      {plans.map((plan) => (
        <Plan
          key={plan.degree.type}
          plan={plan}
          onChange={(updated) => onChange(replacePlan(plans, updated))}
          sharedCourseIds={
            plan.degree.type === 'associate' ? sharedByType.get(plan.degree.type) : undefined
          }
        />
      ))}
    </div>
  );
};
